import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the StripHtmlPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'stripHtml',
})
export class StripHtmlPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return (value) ? value.replace(/<\/?[^>]+>/gi, '') : null;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/strip-html/strip-html.ts